export default __webpack_public_path__ + "static/media/bmr-example-3.4134ee42.png";